import '../plugins/ResponsiveHelper.js';
import '../plugins/TinySmoothScrollPlugin.js';
import { gsap, ScrollSmoother, ScrollToPlugin, ScrollTrigger } from "gsap/all";
import normalizeWheel from 'normalize-wheel';
import SplitType from 'split-type';

// register plugins
gsap.registerPlugin(ScrollSmoother, ScrollToPlugin, ScrollTrigger);
window.gsap = gsap;
window.ScrollSmoother = ScrollSmoother;
window.ScrollTrigger = ScrollTrigger;

const isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
const getWindowHeight = () => window.innerHeight || document.documentElement.clientHeight;
const getRatio = el => getWindowHeight() / (getWindowHeight() + el.offsetHeight);
const eventType = normalizeWheel.getEventType();
const scrolling = {
	enabled: true,
	events: "scroll,wheel,touchmove,pointermove".split(","),
	prevent: e => e.preventDefault(),
	disable() {
		if (scrolling.enabled) {
			scrolling.enabled = false;
			window.addEventListener("scroll", gsap.ticker.tick, { passive: true });
			scrolling.events.forEach((e, i) => (i ? document : window).addEventListener(e, scrolling.prevent, { passive: false }));
		}
	},
	enable() {
		if (!scrolling.enabled) {
			scrolling.enabled = true;
			window.removeEventListener("scroll", gsap.ticker.tick);
			scrolling.events.forEach((e, i) => (i ? document : window).removeEventListener(e, scrolling.prevent));
		}
	}
};

if (ScrollTrigger.isTouch) {
	ScrollTrigger.config({
		ignoreMobileResize: true,
		limitCallbacks: false
	});
}

ScrollTrigger.defaults({
	invalidateOnRefresh: true,
	scrub: true,
	// fastScrollEnd: true,
	ease: 'none',
	overwrite: true
});

function initGSAP() {
	const wheelEventType = normalizeWheel.getEventType();
	const $win = jQuery(window);
	const snapSections = gsap.utils.toArray('.gsap-snap-section');
	const autoscrollSection = document.querySelector('.js-autoscroll-section');
	const smoothWrapper = document.querySelector('#smooth-wrapper');
	const smoothContent = document.querySelector('#smooth-content');
	let smoother = null;
	let isScrolling = false;
	let smoothEnambled = false;
	let anchorScrolling = false;

	if (snapSections.length) {
		document.body.classList.add('has-gsap-snap');
	}

	$win.trigger('smootherInit', smoother);


	if (smoothWrapper && smoothWrapper) {
		// create the smooth scroller
		smoother = ScrollSmoother.create({
			wrapper: smoothWrapper,
			content: smoothContent,
			speed: 0,
			smooth: 0.8, // seconds it takes to "catch up" to native scroll position
			effects: false, // look for data-speed and data-lag attributes on elements and animate accordingly,
			ignoreMobileResize: true,
			normalizeScroll: true,
			smoothTouch: 0.5,
			onUpdate: (inst) => {
				// $win.trigger('smootherUpdate', inst);
			},
			onStop: (inst) => {
				$win.trigger('smootherStop', inst);
			}
		});

		smoothEnambled = true;

		if (!window.location.hash) {
			window.scrollTo(0, 0);
			smoother.scrollTop(0, false);
			smoother.paused(true);
		}
	}

	// init full height video
	document.querySelectorAll('.full-video-section').forEach(container => {
    requestAnimationFrame(() => {
      ScrollTrigger.create({
        trigger: container.querySelector('.js-video-stretch-sticky'),
        start: 'top top',
        endTrigger: '.full-video-block--first',
        end: () => (window.innerWidth < 768 ? '+50%' : 'bottom top'),
        pin: container.querySelector('.js-video-stretch'),
        pinSpacing: false,
        // markers: true,
      });
    });
	});

	// init image zoom on scroll
	document.querySelectorAll('img.js-zoom-image').forEach(img => {
		const trigger = img.closest('.js-fb-gallery-holder') || img;

		if (isTouchDevice) {
			gsap.fromTo(img, {
				scale: 1,
			}, {
				scale: 1.2,
				ease: "none",
				scrollTrigger: {
					trigger: trigger,
					start: 'top top',
					end: 'bottom top'
				}
			});
		}
	});

	// init full height gallery
	document.querySelectorAll('.full-height-gallery').forEach(gallery => {
		let container = gallery.querySelector('.container');
		let item = gallery.querySelector('.container_inner');
		let sections = gallery.querySelectorAll('.full-height_item-gallery-inner');
		let title = gallery.querySelector('.h1');

		function getSectionsWidth() {
			let sectionsWidth = 0;

			sections.forEach((el) => {
				sectionsWidth += el.clientWidth;
			});


			return sectionsWidth;
		}

		gsap.to(sections, {
			x: () => (-1 * (getSectionsWidth() - item.offsetWidth + 0.5)),
			scrollTrigger: {
				trigger: gallery,
				scrub: 1.2,
				start: 'top top',
				end: () => "+=" + getSectionsWidth(),
				onRefresh: () => {},
				onLeave: () => {}
			}
		});

		gsap.to(gallery, {
			scrollTrigger: {
				trigger: gallery,
				scrub: false,
				pin: true,
				anticipatePin: 1,
				start: 'top top',
				end: () => "+=" + (getSectionsWidth() + 200),
				onRefresh: () => {},
				onLeave: () => {}
			}
		});

		gsap.to(title, {
			opacity: 0,
			x: '50%',
			scrollTrigger: {
				trigger: gallery,
				scrub: 2,
				start: 'top top',
				end: () => "+=" + container.offsetWidth / 3
			}
		});
	});

	// init image parallax
	document.querySelectorAll('.gsap-image-parallax').forEach((section, i) => {
		const bg = section.querySelector('.bg');
		const story = section.querySelector('.story-block-inner');
		const text = section.querySelector('.text-center');

		let tweenBg = gsap.fromTo(bg, {
			backgroundPosition: () => `50% 0px`
		}, {
			backgroundPosition: () => `50% ${getWindowHeight() * (1 - getRatio(section))}px`,
			ease: "none",
			scrollTrigger: {
				trigger: section,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true
			}
		});


		if (story) {
			let tweenStory = gsap.fromTo(story, {
				y: () => {
					let y = 0;

					ResponsiveHelper.addRange({
						'768..': {
							on: function() {
								y = (jQuery(section).innerHeight() - jQuery(story).innerHeight()) / 3;
							}
						},
						'..767.98': {
							on: function() {
								y = 0;
							}
						}
					});

					return y;
				}
			}, {
				y: () => {
					let y = 0;

					ResponsiveHelper.addRange({
						'768..': {
							on: function() {
								y = -(jQuery(section).innerHeight() - jQuery(story).innerHeight()) / 3;
							}
						},
						'..767.98': {
							on: function() {
								y = -50;
							}
						}
					});

					return y;
				},
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: 1.5,
				}
			});
		}

		if (text) {
			let tweenText = gsap.fromTo(text, {
				y: () => {
					return (jQuery(section).innerHeight() - jQuery(text).innerHeight()) / 3
				}
			}, {
				y: () => {
					return -(jQuery(section).innerHeight() - jQuery(text).innerHeight()) / 3
				},
				ease: "none",
				scrollTrigger: {
					trigger: section,
					start: 'top bottom',
					end: 'bottom top',
					scrub: 1.5,
				}
			});
		}
	});

	// init smooth elements
	document.querySelectorAll('.gsap-smooth-trigger').forEach(trigger => {
		let triggerOffsetTop = jQuery(trigger).offset().top + 1;
		let resizeObserver = new ResizeObserver(resizeHandler);

		function resizeHandler() {
			triggerOffsetTop = jQuery(trigger).offset().top + 1;
		}

		function getFromOpts(trigger, start = 'top bottom', end = 'top center') {
			return {
				trigger: trigger,
				start: start,
				end: end
			};
		}

		function getToOpts(trigger, start = 'top center', end = 'bottom top') {
			return {
				trigger: trigger,
				start: start,
				end: end
			};
		}


		gsap.fromTo(trigger, {
			opacity: () => {
				if (triggerOffsetTop > getWindowHeight()) {
					return 0
				} else {
					return 1
				}
			},
		}, {
			opacity: 1,
			scrollTrigger: getFromOpts(trigger, 'top bottom', 'top bottom-=100px')
		});

		gsap.fromTo(trigger, {
			opacity: 1
		}, {
			opacity: 0.1,
			scrollTrigger: getToOpts(trigger, 'top top+=50px', 'bottom top')
		});


		resizeObserver.observe(document.body);

		trigger.querySelectorAll('.gsap--anim1').forEach(el => {
			gsap.fromTo(el, {
				y: () => {
					if (triggerOffsetTop > getWindowHeight()) {
						return -50
					} else {
						return 0
					}
				}
			}, {
				y: 0,
				scrollTrigger: getFromOpts(trigger)
			});

			gsap.fromTo(el, {
				y: 0
			}, {
				y: -40,
				scrollTrigger: getToOpts(trigger)
			});
		});

		trigger.querySelectorAll('.gsap--anim2').forEach(el => {
			gsap.fromTo(el, {
				y: () => {
					if (triggerOffsetTop > getWindowHeight()) {
						return 20
					} else {
						return 0
					}
				},
			}, {
				y: 0,
				scrollTrigger: getFromOpts(trigger)
			});

			gsap.fromTo(el, {
				y: 0
			}, {
				y: -10,
				scrollTrigger: getToOpts(trigger)
			});
		});

		trigger.querySelectorAll('.gsap--anim3').forEach(el => {
			gsap.fromTo(el, {
				y: () => {
					if (triggerOffsetTop > getWindowHeight()) {
						return 60
					} else {
						return 0
					}
				},
			}, {
				y: 0,
				scrollTrigger: getFromOpts(trigger)
			});

			gsap.fromTo(el, {
				y: 0
			}, {
				y: 20,
				scrollTrigger: getToOpts(trigger)
			});
		});

		trigger.querySelectorAll('.gsap--anim4').forEach(el => {
			gsap.fromTo(el, {
				y: () => {
					if (triggerOffsetTop > getWindowHeight()) {
						return 60
					} else {
						return 0
					}
				}
			}, {
				y: 0,
				scrollTrigger: getFromOpts(el)
			});

			gsap.fromTo(el, {
				y: 0
			}, {
				y: 30,
				scrollTrigger: getToOpts(el)
			});
		});
	});


	// add scroll to anchors
	document.querySelectorAll('#smooth-wrapper .js-autoscroll-section a[href*="#"]:not([href="#"])').forEach(function(button, i) {
		const target = document.querySelector(button.hash);

		if (target) {
			button.addEventListener('click', (e) => {
				anchorScrolling = true;

				if (smoothEnambled) {
					gsap.to(smoother, {
						scrollTop: parseInt(Math.min(ScrollTrigger.maxScroll(window), smoother.offset(target, 'top 3px'))),
						duration: 0.6,
						scrub: false,
						onComplete: () => {
							anchorScrolling = false;
						}
					});
				} else {
					window.TinySmoothScroll && TinySmoothScroll(jQuery(target).offset().top, ('scrollBehavior' in document.documentElement.style) ? 0 : 600, () => {
						anchorScrolling = false;
					});
				}

				e.preventDefault();
			});
		}
	});

	// init sticky panel
	document.querySelectorAll('#fixed-event-panel').forEach((panel) => {
		const main = document.querySelector('#main');
		let startTarget = document.querySelector(`[data-start-elem-target="#${panel.id}"]`);
		let bottomTarget = document.querySelector(`[data-bottom-elem-target="#${panel.id}"]`);

		if (!startTarget) {
			startTarget = main || document.body;
		}

		if (!bottomTarget) {
			bottomTarget = main || document.body;
		}

		panel.style.display = 'none';

		ScrollTrigger.create({
			trigger: startTarget,
			start: 'bottom bottom',
			onEnter: (e) => toggleVisible(true),
			onLeaveBack: (e) => toggleVisible(false)
		});

		ScrollTrigger.create({
			trigger: bottomTarget,
			start: 'top bottom',
			onEnter: (e) => toggleVisible(false),
			onLeaveBack: (e) => toggleVisible(true)
		});

		function toggleVisible(state) {
			if (state) {
				panel.style.display = '';
			} else {
				panel.style.display = 'none';
			}
		}
	});

  // https://gsap.com/community/forums/topic/40960-stagger-text-fill-on-scroll/
  const split = new SplitType('.gsap-scroll-reveal p', {
    types: 'lines, words, chars',
  });

  const text = document.querySelectorAll('.gsap-scroll-reveal');
  text.forEach((el) => {
    el.style.color = '#ffffff4d';
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.gsap-snap-section#block-main',
      start: '-=40%',
      end: '+=65%',
      // pin: true,
      scrub: 0.1,
      // markers: true,
    },
  });

  tl.to(split.chars, {
    color: '#dadada',
    stagger: 1,
  });

	function scrollToHash(hash, e) {
		const elem = hash ? document.querySelector(hash) : false;
		if (elem) {
			if (e) e.preventDefault();
      if(smoother) {
        smoother.scrollTo(elem, true)
      } else {
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 50
        }, 200);
      }
		}
	}

	function initSnapScroll() {
		if (ScrollTrigger.isTouch || !smoothEnambled || !autoscrollSection) return;

		ScrollTrigger.create({
			trigger: autoscrollSection,
			start: 2,
			invalidateOnRefresh: true,
			onEnter: (e) => goToSection(autoscrollSection, 'enter')
		});

		ScrollTrigger.create({
			trigger: autoscrollSection,
			start: 'bottom bottom',
			invalidateOnRefresh: true,
			onEnterBack: (e) => goToSection(autoscrollSection, 'back')
		});

		// autoscroll to second section
		function goToSection(section, e) {
			if (!anchorScrolling && !smoother.paused() && scrolling.enabled) { // skip if a scroll tween is in progress
				scrolling.disable();

				if (e == 'back') {
					gsap.to(smoother, {
						scrollTop: 0,
						duration: 0.6,
						scrub: false,
						overwrite: true,
						onEnter: () => {
							isScrolling = true;
						},
						onComplete: () => {
							isScrolling = false;
							scrolling.enable();
						}
					});
				} else {
					gsap.to(smoother, {
						scrollTo: { y: Math.min(ScrollTrigger.maxScroll(window), smoother.offset(section, 'bottom -2px')), autoKill: false },
						duration: 0.6,
						scrub: false,
						overwrite: true,
						onEnter: () => {
							isScrolling = true;
						},
						onComplete: () => {
							isScrolling = false;
							scrolling.enable();
						}
					});
				}
			}
		}

		$win.on('smootherUpdate', () => {
			// isScrolling = true;
		});

		$win.on('smootherStop', () => {
			isScrolling = false;
			scrolling.enable();
		});
	}

	// init smooth flexmasonry
	initFlexmasonryTween();

	// must be last
	if (window.location.hash) {
		scrollToHash(window.location.hash);
	}

	if (smoother) {
		smoother.paused(false);

		document.addEventListener(eventType, initSnapScroll, { once: true });
	}
}

// flexmasonry moving
function initFlexmasonryTween($holder = jQuery('body')) {
	$holder.find('.js-flexmasonry-gsap').each((i, grid) => {
		const $grid = jQuery(grid);
		let $leftElems = $grid.find('.grid-item:nth-child(3n - 2)');
		let $centerElems = $grid.find('.grid-item:nth-child(3n - 1)');
		let $rightElems = $grid.find('.grid-item:nth-child(3n)');
		let timer = null;

		ScrollTrigger.matchMedia({
			// desktop
			"(min-width: 1024px)": function() {
				$leftElems = $grid.find('.grid-item:nth-child(3n - 2)');
				$centerElems = $grid.find('.grid-item:nth-child(3n - 1)');
				$rightElems = $grid.find('.grid-item:nth-child(3n)');

				initTween($leftElems, $centerElems, $rightElems);
			},

			// tablet
			"(min-width: 480px)": function() {
				$leftElems = $grid.find('.grid-item:nth-child(2n - 1)');
				$centerElems = $grid.find('.grid-item:nth-child(2n)');

				initTween($leftElems, $centerElems);
			}
		});

		function initTween($leftElems, $centerElems, $rightElems) {
			if ($leftElems) {
				$leftElems.each((i, parent) => {
					const el = parent.children[0];
					const tween = gsap.fromTo(el, {
						y: 0
					}, {
						y: -50,
						ease: "power1.inOut",
						scrollTrigger: {
							trigger: parent,
							start: () => {
								if (jQuery(parent).offset().top > getWindowHeight()) {
									return 'top bottom'
								} else {
									return 0;
								}
							},
							end: 'bottom 25%',
							scrub: 2,
						}
					});
				});
			}
			if ($centerElems) {
				$centerElems.each((i, parent) => {
					const el = parent.children[0];
					const tween = gsap.fromTo(el, {
						y: 0
					}, {
						y: -100,
						ease: "power1.inOut",
						scrollTrigger: {
							trigger: parent,
							start: () => {
								if (jQuery(parent).offset().top > getWindowHeight()) {
									return 'top bottom'
								} else {
									return 0;
								}
							},
							end: 'bottom 25%',
							scrub: 2,
						}
					});
				});
			}
			if ($rightElems) {
				$rightElems.each((i, parent) => {
					const el = parent.children[0];
					const tween = gsap.fromTo(el, {
						y: 0
					}, {
						y: -150,
						ease: "power1.inOut",
						scrollTrigger: {
							trigger: parent,
							start: () => {
								if (jQuery(parent).offset().top > getWindowHeight()) {
									return 'top bottom'
								} else {
									return 0;
								}
							},
							end: 'bottom 25%',
							scrub: 2,
						}
					});
				});
			}
		}
	});
}

export { initGSAP, initFlexmasonryTween };
